import React from 'react'
import { timeAgo } from './utils'

const TimeAgo = ({ date }) => {
  return <> {timeAgo(date)}</>
}

export default TimeAgo
